<template>
  <base-form-field
    class="ps-h-12 ps-text-title ps-flex ps-items-center ps-font-semibold"
    :label="label"
    input-name="InputUnderline"
    v-model="$v.name.$model"
    :vuelidate="$v.name"
    :hide-label="true"
    placeholder="Card Name"
  >
  </base-form-field>
</template>

<script>
import BaseFormData from '@/components/forms/BaseFormData'
import BaseFormField from '@/components/forms/BaseFormField'
import BaseInput from '@/components/inputs/BaseInput'
export default {
  name: 'CardHeader',
  extends: BaseFormData,
  props: {
    label: {
      type: String,
      required: true
    }
  },
  components: {
    BaseFormField,
    BaseInput
  }
}
</script>
